<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Visitor Gatepass" />

        <div class="rec_count text-danger">
            <ul class="action">
                <li>All : {{all_pass_count}}</li>
                <li>Completed : {{completed_pass_count}}</li>
                <li>Requested : {{requested_pass_count}}</li>
            </ul>
        </div>




        <!-- mobile view -->
        <div class="container-fluid mobile_view" v-if="isMobileView()">
            <div class="col-xxl-12">
                <div class="card">
                    <div class="card-header">

                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border txt-danger nav-danger"
                                    id="ongoing-tab" data-bs-toggle="tab" href="#ongoing" role="tab"
                                    aria-controls="ongoing" aria-selected="false"><i
                                        class="icofont icofont-file-document"></i>Today</a></li>

                            <li class="nav-item"><a class="nav-link nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a>
                            </li>
 

                            <li> <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                                    data-original-title="test" data-bs-target="#gatepassAdd"><i
                                        class="icofont icofont-id-card"></i>Create</button>
                            </li>
                        </ul>
                    </div>

                    <div class="col3">



                    </div>

                    <div class="card-body">
                        <div class="tab-content" id="topline-tabContent">
                            <!-- All Gatepass Tab -->
                            <div class="tab-pane fade" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0 pt-0">
                                    <div class="form-group d-flex align-items-center pb-2 gap-2">
                                        <input type="text" v-model="search_text_all" class="form-control"
                                            placeholder="Search..." />

                                        <span class="badge bg-success" @click="filterlist"
                                            style="height:30px;cursor: pointer">
                                            Filter
                                        </span>

                                        <span class="badge bg-primary text-white" v-if="reschedule.length > 0"
                                            data-bs-toggle="modal" data-bs-target="#rescheduleHere"
                                            style="cursor: pointer">
                                            <i class="icofont icofont-ui-reply text-warning"></i> Reschedule
                                        </span>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 mb-3  " v-for="(item, index) in filterd_gatepass"
                                            :key="index">
                                            <div class="  h-100" :class="{
                                                    'pass_card-warning': item.approval_status==0 ,
                                                    'pass_card-success': item.approval_status==1,
                                                    'pass_card-danger': item.approval_status==2
                                                }">
                                                <div class="card-header d-flex justify-content-between align-items-center text-white"
                                                    :class="{
                                                    'bg-warning': item.approval_status==0 ,
                                                    'bg-success': item.approval_status==1,
                                                    'bg-danger': item.approval_status==2
                                                }">
                                                    <span class=" text-white">#{{ index+1 }} - {{ item.schedule_date
                                                        }}</span>
                                                    <input type="checkbox"
                                                        @click="() => { selectUsers(item.visitor_id) }"
                                                        :value="item.id" />
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex align-items-center mb-3">
                                                        <a target="_blank" @click="_showingUserPic(item)"
                                                            itemprop="contentUrl" data-size="1600x950">
                                                            <img alt="" :src="getImageUrl(item)"
                                                                v-if="item.gphoto || item.photo" class="avatar me-3"
                                                                itemprop="thumbnail" :alt="item.name">
                                                        </a>
                                                        <div>
                                                            <h5 class="mb-1"> <strong>{{ item.name }} </strong>
                                                                <span
                                                                    v-if="item.designation && item.designation.length > 0"
                                                                    class="badge_sm badge-info">
                                                                    {{ item.designation }}
                                                                </span>
                                                                <small v-if="item.workpermit_id>0"
                                                                    class="word_permit ms-1">WP</small>
                                                            </h5>
                                                            <p class="mb-1"> <strong>{{ item.firmname }} </strong> {{
                                                                item.address }} </p>
                                                            <p class="mb-1"> {{ item.contact }}</p>

                                                        </div>
                                                    </div>

                                                    <div class="mb-1">
                                                        <strong>Purpose:</strong> {{ item.purpose }}
                                                        <span v-if="item.meeting_room"
                                                            class="badge_sm badge-primary ms-1">
                                                            {{ item.meeting_room }}
                                                            <a class="badge bg-success"
                                                                v-if="item.meeting_room_status==1"
                                                                @click="mettingCompletedFromPass(item.gatepassid)">Realease
                                                                Room</a>
                                                        </span>
                                                    </div>

                                                    <div class="mb-1" v-if="user.empdept==sd || user.emprole==1">
                                                        <strong>Staff:</strong> {{ item.whom_name }}
                                                    </div>

                                                    <div class="mb-1">
                                                        <strong>Accessories:</strong> {{ item.accessories || '' }}
                                                        <span title="edit" v-if="user.empdept==sd && item.check_in == null"
                                                            class="badge_sm bg-success ms-1"
                                                            @click="editaccessories(item.gatepassid)">
                                                            <i class="icofont icofont-ui-add"></i>
                                                        </span>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-1">
                                                        <div>
                                                            <strong>Check In:</strong>
                                                            <div
                                                                v-if="user.empdept == sd && item.check_in == null && item.approval_status == 1">
                                                                <button title="Mark Check In"
                                                                    class="btn btn-primary btn-sm"
                                                                    @click=" first_capture_photo(item.gatepassid,item.id)">
                                                                    Check In
                                                                </button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_in || '--' }}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <strong>Check Out:</strong>
                                                            <div
                                                                v-if="user.empdept == sd && item.check_out == null && item.check_in != null">
                                                                <button title="Mark Checkout"
                                                                    class="btn btn-primary btn-sm"
                                                                    @click="mark_checkin(item.gatepassid, 2)">
                                                                    Check Out
                                                                </button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_out || '--' }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mb-1">
                                                        <strong>Active Time:</strong>
                                                        <template v-if="item.check_out">
                                                            {{ timeDiff(item.check_in, item.check_out) }}
                                                        </template>
                                                        <template v-else-if="!item.check_in && !item.check_out">
                                                            0
                                                        </template>
                                                        <template v-else-if="item.check_in && !item.check_out">
                                                            {{ getCheckInDiff(item.check_in) }}
                                                        </template>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-1">
                                                        <div>
                                                            <strong>Check In :</strong><br>
                                                            <div v-if="item.approval_status == 0"
                                                                class="badge bg-warning">Pending</div>
                                                            <div v-else-if="item.approval_status == 1"
                                                                class="badge bg-success">Accepted</div>
                                                            <div v-else-if="item.approval_status == 2"
                                                                class="badge bg-danger">Denied</div>

                                                            <div v-if="item.approval_status == 0 && item.whom_userid==user.id"
                                                                class="mt-1">
                                                                <button title="Approve" class="btn btn-success btn-sm"
                                                                    @click="accept(item)">
                                                                    <i class="icon-check"></i> Approve
                                                                </button>
                                                                <button title="Decline"
                                                                    class="btn btn-danger btn-sm ms-1"
                                                                    @click="reject(item)">
                                                                    <i class="icon-close"></i> Decline
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <strong>Check Out:</strong><br>
                                                            <div
                                                                v-if="user.id == item.whom_userid && item.check_in != null && item.checkout_approval == 0">
                                                                <span title="Approve Checkout" class="badge bg-danger"
                                                                    @click="approve_checkout(item.token, 1)">
                                                                    Approve
                                                                </span>
                                                            </div>
                                                            <div v-else>
                                                                <div v-if="item.checkout_approval == 0 && !item.check_out"
                                                                    class="badge bg-warning">Pending</div>
                                                                <div v-else-if="item.checkout_approval == 1"
                                                                    class="badge bg-success">Accepted</div>
                                                                <div v-else-if="item.checkout_approval == 2"
                                                                    class="badge bg-danger">Denied</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <div class="d-flex flex-wrap gap-2">
                                                        <button class="btn btn-sm btn-outline-primary"
                                                            v-if="item.approval_status == 1"
                                                            @click="getQrCode(item.token)">
                                                            <i class="icofont icofont-qr-code"></i> QR
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-secondary"
                                                            v-if="item.approval_status == 0 && item.whom_userid == user.id"
                                                            @click="editGatepass(item)">
                                                            <i class="icon-pencil-alt"></i> Edit
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-info"
                                                            @click="print_pass(item.gatepassid)">
                                                            <i class="icon-printer"></i> Print
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-primary"
                                                            v-if="user.empdept != sd && !item.meeting_room"
                                                            @click="meetingroomBook(item)">
                                                            <i class="icon-home"></i> Room
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-danger"
                                                            v-if="item.whom_userid != user.id && item.approval_status==0"
                                                            @click="removeGatepass(item.gatepassid)">
                                                            <i class="icon-trash"></i> Delete
                                                        </button>
                                                    </div>
                                                    <span class="text-muted text_sm">{{item.iddate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Ongoing Gatepass Tab -->
                            <div class="tab-pane fade show active" id="ongoing" role="tabpanel"
                                aria-labelledby="ongoing-tab">
                                <!--Today Gatepass-->
                                <div class="card-body px-0 pb-0 pt-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Today Gatepass:</h6>

                                        <div class="d-flex gap-2">

                                            <label><input type="checkbox" value="stop" @click="stop_interval()">Stop
                                                Refresh</label>
                                            <label><input type="radio" name="IN" 
                                                    @click="filter_list(0)">IN</label>
                                            <label><input type="radio" name="IN"
                                                    @click="filter_list(1)">Out</label>
                                            <label><input type="radio" name="IN"
                                                    @click="filter_list(2)">Expected</label>
                                                <label><input type="radio" name="IN"
                                                        @click="filter_list(3)">All</label>

                                        </div>


                                        <div class="form-group d-flex align-items-center pb-2 gap-2">
                                            <input type="text" v-model="search_text_today" class="form-control"
                                                placeholder="Search..." />


                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4 mb-3" v-for="(item, index) in filterd_ongoing_pass"
                                            :key="index">
                                            <div class="  h-100" :class="{
                                                    'pass_card-warning': item.approval_status==0 ,
                                                    'pass_card-success': item.approval_status==1,
                                                    'pass_card-danger': item.approval_status==2
                                                }">
                                                <div class="card-header d-flex justify-content-between align-items-center text-white"
                                                    :class="{
                                                    'bg-warning': item.approval_status==0 ,
                                                    'bg-success': item.approval_status==1,
                                                    'bg-danger': item.approval_status==2
                                                }">
                                                    <span class=" text-white">#{{ index+1 }} - {{ item.schedule_date
                                                        }}</span>
                                                    <!--<input type="checkbox" @click="() => { selectUsers(item.visitor_id) }" :value="item.id" />-->
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex align-items-center mb-3">
                                                        <a target="_blank" @click="_showingUserPic(item)"
                                                            itemprop="contentUrl" data-size="1600x950">
                                                            <img alt="" :src="getImageUrl(item)"
                                                                v-if="item.gphoto || item.photo" class="avatar me-3"
                                                                itemprop="thumbnail" :alt="item.name">
                                                        </a>
                                                        <div>
                                                            <h5 class="mb-1"> <strong>{{ item.name }} </strong>
                                                                <span
                                                                    v-if="item.designation && item.designation.length > 0"
                                                                    class="badge_sm badge-info">
                                                                    {{ item.designation }}
                                                                </span>
                                                                <small v-if="item.workpermit_id>0"
                                                                    class="word_permit ms-1">WP</small>
                                                            </h5>
                                                            <p class="mb-1"> <strong>{{ item.firmname }} </strong> {{
                                                                item.address }} </p>
                                                            <p class="mb-1"> {{ item.contact }}</p>

                                                        </div>
                                                    </div>

                                                    <div class="mb-1">
                                                        <strong>Purpose:</strong> {{ item.purpose }}
                                                        <span v-if="item.meeting_room"
                                                            class="badge_sm badge-primary ms-1">
                                                            {{ item.meeting_room }}
                                                            <a class="badge bg-success"
                                                                v-if="item.meeting_room_status==1"
                                                                @click="mettingCompletedFromPass(item.gatepassid)">Realease
                                                                Room</a>
                                                        </span>
                                                    </div>

                                                    <div class="mb-1" v-if="user.empdept==sd || user.emprole==1">
                                                        <strong>Staff:</strong> {{ item.whom_name }}
                                                    </div>

                                                    <div class="mb-1">
                                                        <strong>Accessories:</strong> {{ item.accessories || '' }}
                                                        <span title="edit" v-if="user.empdept==sd && item.check_in == null"
                                                            class="badge_sm bg-success ms-1"
                                                            @click="editaccessories(item.gatepassid)">
                                                            <i class="icofont icofont-ui-add"></i>
                                                        </span>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-1">
                                                        <div>
                                                            <strong>Check In:</strong>
                                                            <div
                                                                v-if="user.empdept == sd && item.check_in == null && item.approval_status == 1">
                                                                <button title="Mark Check In"
                                                                    class="btn btn-primary btn-sm"
                                                                    @click=" first_capture_photo(item.gatepassid,item.id)">
                                                                    Check In
                                                                </button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_in || '--' }}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <strong>Check Out:</strong>
                                                            <div
                                                                v-if="user.empdept == sd && item.check_out == null && item.check_in != null">
                                                                <button title="Mark Checkout"
                                                                    class="btn btn-primary btn-sm"
                                                                    @click="mark_checkin(item.gatepassid, 2)">
                                                                    Check Out
                                                                </button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_out || '--' }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mb-1">
                                                        <strong>Active Time:</strong>
                                                        <template v-if="item.check_out">
                                                            {{ timeDiff(item.check_in, item.check_out) }}
                                                        </template>
                                                        <template v-else-if="!item.check_in && !item.check_out">
                                                            0
                                                        </template>
                                                        <template v-else-if="item.check_in && !item.check_out">
                                                            {{ getCheckInDiff(item.check_in) }}
                                                        </template>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-1">
                                                        <div>
                                                            <strong>Check In :</strong><br>
                                                            <div v-if="item.approval_status == 0"
                                                                class="badge bg-warning">Pending</div>
                                                            <div v-else-if="item.approval_status == 1"
                                                                class="badge bg-success">Accepted</div>
                                                            <div v-else-if="item.approval_status == 2"
                                                                class="badge bg-danger">Denied</div>

                                                            <div v-if="item.approval_status == 0 && item.whom_userid==user.id"
                                                                class="mt-1">
                                                                <button title="Approve" class="btn btn-success btn-sm"
                                                                    @click="accept(item)">
                                                                    <i class="icon-check"></i> Approve
                                                                </button>
                                                                <button title="Decline"
                                                                    class="btn btn-danger btn-sm ms-1"
                                                                    @click="reject(item)">
                                                                    <i class="icon-close"></i> Decline
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <strong>Check Out:</strong><br>
                                                            <div
                                                                v-if="user.id == item.whom_userid && item.check_in != null && item.checkout_approval == 0">
                                                                <span title="Approve Checkout" class="badge bg-danger"
                                                                    @click="approve_checkout(item.token, 1)">
                                                                    Approve
                                                                </span>
                                                            </div>
                                                            <div v-else>
                                                                <div v-if="item.checkout_approval == 0 && !item.check_out"
                                                                    class="badge bg-warning">Pending</div>
                                                                <div v-else-if="item.checkout_approval == 1"
                                                                    class="badge bg-success">Accepted</div>
                                                                <div v-else-if="item.checkout_approval == 2"
                                                                    class="badge bg-danger">Denied</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <div class="d-flex flex-wrap gap-2">
                                                        <button class="btn btn-sm btn-outline-primary"
                                                            v-if="item.approval_status == 1"
                                                            @click="getQrCode(item.token)">
                                                            <i class="icofont icofont-qr-code"></i> QR
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-secondary"
                                                            v-if="item.approval_status == 0 && item.whom_userid == user.id"
                                                            @click="editGatepass(item)">
                                                            <i class="icon-pencil-alt"></i> Edit
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-info"
                                                            @click="print_pass(item.gatepassid)">
                                                            <i class="icon-printer"></i> Print
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-primary"
                                                            v-if="user.empdept != sd && !item.meeting_room"
                                                            @click="meetingroomBook(item)">
                                                            <i class="icon-home"></i> Room
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-danger"
                                                            v-if="item.whom_userid != user.id && item.approval_status==0"
                                                            @click="removeGatepass(item.gatepassid)">
                                                            <i class="icon-trash"></i> Delete
                                                        </button>
                                                    </div>
                                                    <span class="text-muted text_sm">{{item.iddate}}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- mobile view -->







        <div v-else class="container-fluid">
            <div class="col-xxl-12">
                <div class="card">
                    <div class="card-header">

                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border txt-danger nav-danger"
                                    id="ongoing-tab" data-bs-toggle="tab" href="#ongoing" role="tab"
                                    aria-controls="ongoing" aria-selected="false"><i
                                        class="icofont icofont-file-document"></i>Today</a></li>

                            <li class="nav-item"><a class="nav-link nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a>
                            </li>

                            <li class="nav-item" v-if="user.empdept==sd"><a
                                    class="nav-link nav-border pt-0 txt-danger nav-danger" id="report_table-tab"
                                    data-bs-toggle="tab" href="#report_table_tab" role="tab"
                                    aria-controls="report_table" aria-selected="true"><i
                                        class="icofont icofont-chart-bar-graph"></i>Report</a>
                            </li>
                            <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="requested-tab"-->
                            <!--        data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"-->
                            <!--        aria-selected="false"><i class="icofont icofont-file-document"></i>Requested</a>-->
                            <!--</li>-->
                            <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger"-->
                            <!--        id="completed-gatepass-tab" data-bs-toggle="tab" href="#completed-gatepass"-->
                            <!--        role="tab" aria-controls="completed-gatepass" aria-selected="false"><i-->
                            <!--            class="icofont icofont-star"></i>Completed</a></li>-->

                            <!--<li> <h6 class="fw-bold">All Gate Pass:</h6> </li>-->

                            <li> <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                                    data-original-title="test" data-bs-target="#gatepassAdd"><i
                                        class="icofont icofont-id-card"></i> Create Gatepass</button>
                            </li>
                        </ul>
                    </div>

                    <div class="col3">

                        <!--<span class="badge bg-success ms-4 mt-2"  @click="filterlist">Filter</span>-->

                    </div>

                    <div class="card-body">
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade  " id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0 pt-0">
                                    <div class="user-header pb-2">

                                        <span class="badge bg-primary text-white" v-if="reschedule.length > 0"
                                            data-bs-toggle="modal" data-original-title="test"
                                            data-bs-target="#rescheduleHere"> <i
                                                class="icofont icofont-ui-reply text-warning"></i> Reschedule</span>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="all_table">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Sr</th>
                                                        <th>Date</th>
                                                        <th>Photo</th>
                                                        <th>Visitor</th>
                                                        <th>Firmname</th>
                                                        <th>Contact</th>
                                                        <th>Purpose</th>
                                                        <th v-if="user.empdept==sd || user.emprole==1">Staff</th>
                                                        <th>Accessories</th>
                                                        <th>Check In</th>
                                                        <th>Check Out</th>
                                                        <th>Active Time</th>
                                                        <th>Check In Status</th>
                                                        <th>Check Out Status</th>
                                                        <th>Adhar Card</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in filterd_gatepass"
                                                        :key="index">
                                                        <td><input type="checkbox"
                                                                @click="() => { selectUsers(item.visitor_id) }"
                                                                :value="item.id" /></td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.schedule_date }}</td>
                                                        <td><a target="_blank" @click="_showingUserPic(item)"
                                                                itemprop="contentUrl" data-size="1600x950">
                                                                <img alt="" :src="getImageUrl(item)"
                                                                    v-if="item.gphoto || item.photo" class="avatar "
                                                                    itemprop="thumbnail" :alt="item.name">
                                                            </a>
                                                            <small v-if="item.workpermit_id>0"
                                                                class="word_permit">WP</small>

                                                        </td>
                                                        <td>{{ item.name }} <span
                                                                v-if="item.designation && item.designation.length > 0"
                                                                class="badge_sm badge-info">{{
                                                                item.designation }}</span> </td>
                                                        <td>
                                                            {{ item.firmname }} <span
                                                                v-if="item.address && item.address.length > 0"
                                                                class="badge_sm badge-primary">{{ item.address
                                                                }}</span>
                                                        </td>
                                                        <td>{{ item.contact }}</td>
                                                        <td>{{ item.purpose }} <span
                                                                v-if="item.meeting_room && item.meeting_room"
                                                                class="badge_sm badge-primary">{{ item.meeting_room }}
                                                                <a class="badge bg-success"
                                                                    v-if="item.meeting_room_status==1"
                                                                    @click="mettingCompletedFromPass(item.gatepassid)">Realease
                                                                    Room</a></span>
                                                        </td>

                                                        <td v-if="user.empdept==sd || user.emprole==1">{{ item.whom_name
                                                            }}</td>
                                                        <td>{{ item.accessories }}

                                                            <span title="edit" class="badge_sm bg-success"  v-if="user.empdept==sd && item.check_in == null"
                                                                @click="editaccessories(item.gatepassid)">
                                                                <i class="icofont icofont-ui-add"></i>
                                                            </span>

                                                        </td>

                                                        <td>

                                                            <div
                                                                v-if="user.empdept == sd && item.check_in == null && item.approval_status == 1">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                    @click="first_capture_photo(item.gatepassid,item.id)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_in }}
                                                            </div>

                                                        </td>
                                                        <td>
                                                            <div
                                                                v-if="user.empdept == sd && item.check_out == null && item.check_in != null ">
                                                                <button title="Mark Checkout" class="btn btn-primary"
                                                                    @click="mark_checkin(item.gatepassid, 2)">Check
                                                                    Out</button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_out }}
                                                            </div>
                                                        </td>


                                                        <td>



                                                            <template v-if="item.check_out">
                                                                {{ timeDiff(item.check_in, item.check_out) }}
                                                            </template>
                                                            <template v-else-if="!item.check_in && !item.check_out">
                                                                0
                                                            </template>
                                                            <template v-else-if="item.check_in && !item.check_out">
                                                                {{ getCheckInDiff(item.check_in) }}
                                                            </template>
                                                        </td>


                                                        <td>


                                                            <div v-if="item.approval_status == 0"
                                                                class="badge bg-warning">Pending</div>
                                                            <div v-else-if="item.approval_status == 1"
                                                                class="badge bg-success">Accepted</div>
                                                            <div v-else-if="item.approval_status == 2"
                                                                class="badge bg-danger">Denied</div>

                                                            <ul class="action mt-2" v-if="item.approval_status == 0">

                                                                <template v-if="item.whom_userid==user.id">
                                                                    <button title="Approve" class="btn-success"
                                                                        @click="accept(item)">
                                                                        <i class="icon-check"></i>
                                                                    </button>
                                                                    &nbsp;
                                                                    <button title="Decline" class="btn-danger"
                                                                        @click="reject(item)">
                                                                        <i class="icon-close "></i>
                                                                    </button>
                                                                </template>
                                                            </ul>
                                                        </td>
                                                        <td>
                                                            <div
                                                                v-if="user.id == item.whom_userid && item.check_in != null && item.checkout_approval == 0">
                                                                <span title="Approve Checkout" class="badge bg-danger"
                                                                    @click="approve_checkout(item.token, 1)">Approve</span>
                                                            </div>
                                                            <div v-else>

                                                                <div v-if="item.checkout_approval == 0"
                                                                    class="badge bg-warning">Pending</div>
                                                                <div v-else-if="item.checkout_approval == 1"
                                                                    class="badge bg-success">Accepted {{
                                                                    item.checkout_approval_time }}</div>
                                                                <div v-else-if="item.checkout_approval == 2"
                                                                    class="badge bg-danger">Denied</div>
                                                            </div>
                                                        </td>
                                                        <td><a target="_blank" @click="_showingUserPic(item,true)"
                                                                itemprop="contentUrl" data-size="1600x950">
                                                                <img alt="" :src="getAdharImage(item.aadharcard)"
                                                                    v-if="item.gphoto || item.photo" class="avatar "
                                                                    itemprop="thumbnail" :alt="item.name">
                                                            </a>

                                                        </td>
                                                        <td>
                                                            <ul class="action" v-if="user.empdept != sd">
                                                                <li class="link" v-if="item.approval_status == 1"
                                                                    @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li>

                                                                <li class="edit" v-if="item.approval_status == 0"
                                                                    @click=""><i class="icon-pencil-alt"></i></li>
                                                                <li title="Room Reservation" v-if="!item.meeting_room"
                                                                    @click="meetingroomBook(item)">
                                                                    <i class="icon-home text-primary"></i>
                                                                </li>
                                                                <!--   <li class="link" @click="openlink(item)"><i
                                                                        class="icon-link"></i></li>-->
                                                                <li title="Delete Pass"  v-if="item.whom_userid != user.id && item.approval_status==0"
                                                                    @click="removeGatepass(item.gatepassid)"><i
                                                                        class="icon-trash text-danger"></i></li>
                                                                <li title="Print Pass"
                                                                    @click="print_pass(item.gatepassid)"><i
                                                                        class="icon-printer"></i></li>
                                                            </ul>
                                                            <ul class="action" v-else>
                                                                <li class="link" v-if="item.approval_status == 1"
                                                                    @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li>

                                                                <li title="Print Pass"
                                                                    @click="print_pass(item.gatepassid)"><i
                                                                        class="icon-printer"></i></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade  show active" id="ongoing" role="tabpanel"
                                aria-labelledby="ongoing-tab">
                                <div class="card-body px-0 pb-0 pt-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Today Gatepass:
                                            <span style="float: right;">

                                                <label><input type="checkbox" value="stop" @click="stop_interval()">Stop
                                                    Refresh</label>
                                                <label><input type="radio" name="IN"
                                                        @click="filter_list(0)">In</label>
                                                <label><input type="radio" name="IN"
                                                        @click="filter_list(1)">Out</label>
                                                <label><input type="radio" name="IN"
                                                        @click="filter_list(2)">Expected</label>
                                                <label><input type="radio" name="IN"
                                                        @click="filter_list(3)">All</label>

                                            </span>
                                        </h6>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="ongoing_table">
                                                <thead>
                                                    <tr>
                                                        <!--<th></th>-->
                                                        <th>Sr</th>
                                                        <th>Date</th>
                                                        <th>Photo</th>
                                                        <th>Visitor</th>
                                                        <th>Firmname</th>
                                                        <th>Contact</th>
                                                        <th>Purpose</th>
                                                        <th v-if="user.empdept==sd || user.emprole==1">Staff</th>
                                                        <th>Accessories</th>
                                                        <th>Check In</th>
                                                        <th>Check Out</th>
                                                        <th>Active Time</th>
                                                        <th>Check In Status</th>
                                                        <th>Check Out Status</th>
                                                        <th>Adhar Card</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in filterd_ongoing_pass" :key="index">
                                                        <!--<td><input type="checkbox" @click="() => { selectUsers(item.visitor_id) }"-->
                                                        <!--        :value="item.id" /></td>-->
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.schedule_date }}</td>
                                                        <td><a target="_blank" @click="_showingUserPic(item)"
                                                                itemprop="contentUrl" data-size="1600x950">
                                                                <img alt="" :src="getImageUrl(item)"
                                                                    v-if="item.gphoto || item.photo" class="avatar "
                                                                    itemprop="thumbnail" :alt="item.name">
                                                            </a>
                                                            <small v-if="item.workpermit_id>0"
                                                                class="word_permit">WP</small>

                                                        </td>
                                                        <td>{{ item.name }} <span
                                                                v-if="item.designation && item.designation.length > 0"
                                                                class="badge_sm badge-info">{{
                                                                item.designation }}</span> </td>
                                                        <td>
                                                            {{ item.firmname }} <span
                                                                v-if="item.address && item.address.length > 0"
                                                                class="badge_sm badge-primary">{{ item.address
                                                                }}</span></td>
                                                        <td>{{ item.contact }}</td>
                                                        <td>{{ item.purpose }} <span
                                                                v-if="item.meeting_room && item.meeting_room!=''"
                                                                class="badge_sm badge-primary">{{ item.meeting_room }}
                                                                <a class="badge bg-success"
                                                                    v-if="item.meeting_room_status==1"
                                                                    @click="mettingCompletedFromPass(item.gatepassid)">Realease
                                                                    Room</a></span>
                                                        </td>

                                                        <td v-if="user.empdept==sd || user.emprole==1">{{ item.whom_name
                                                            }}</td>
                                                        <td>{{ item.accessories }}

                                                            <span title="edit" class="badge_sm bg-success"  v-if="user.empdept==sd && item.check_in == null"
                                                                @click="editaccessories(item.gatepassid)">
                                                                <i class="icofont icofont-ui-add"></i>
                                                            </span>

                                                        </td>

                                                        <td>

                                                            <div
                                                                v-if="user.empdept == sd && item.check_in == null && item.approval_status == 1">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                    
                                                                     @click="first_capture_photo(item.gatepassid,item.id)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_in }}
                                                            </div>

                                                        </td>
                                                        <td>
                                                            <div
                                                                v-if="user.empdept == sd && item.check_out == null && item.check_in != null ">
                                                                <button title="Mark Checkout" class="btn btn-primary"
                                                                    @click="mark_checkin(item.gatepassid, 2)">Check
                                                                    Out</button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.check_out }}
                                                            </div>
                                                        </td>


                                                        <td>



                                                            <template v-if="item.check_out">
                                                                {{ timeDiff(item.check_in, item.check_out) }}
                                                            </template>
                                                            <template v-else-if="!item.check_in && !item.check_out">
                                                                0
                                                            </template>
                                                            <template v-else-if="item.check_in && !item.check_out">
                                                                {{ getCheckInDiff(item.check_in) }}
                                                            </template>
                                                        </td>


                                                        <td>


                                                            <div v-if="item.approval_status == 0"
                                                                class="badge bg-warning">Pending</div>
                                                            <div v-else-if="item.approval_status == 1"
                                                                class="badge bg-success">Accepted</div>
                                                            <div v-else-if="item.approval_status == 2"
                                                                class="badge bg-danger">Denied</div>

                                                            <ul class="action mt-2" v-if="item.approval_status == 0">

                                                                <template v-if="item.whom_userid==user.id">
                                                                    <button title="Approve" class="btn-success"
                                                                        @click="accept(item)">
                                                                        <i class="icon-check"></i>
                                                                    </button>
                                                                    &nbsp;
                                                                    <button title="Decline" class="btn-danger"
                                                                        @click="reject(item)">
                                                                        <i class="icon-close "></i>
                                                                    </button>
                                                                </template>
                                                            </ul>
                                                        </td>
                                                        <td>
                                                            <div
                                                                v-if="user.id == item.whom_userid && item.check_in != null && item.checkout_approval == 0">
                                                                <span title="Approve Checkout" class="badge bg-danger"
                                                                    @click="approve_checkout(item.token, 1)">Approve</span>
                                                            </div>
                                                            <div v-else>

                                                                <div v-if="item.checkout_approval == 0"
                                                                    class="badge bg-warning">Pending</div>
                                                                <div v-else-if="item.checkout_approval == 1"
                                                                    class="badge bg-success">Accepted {{
                                                                    item.checkout_approval_time }}</div>
                                                                <div v-else-if="item.checkout_approval == 2"
                                                                    class="badge bg-danger">Denied</div>
                                                            </div>
                                                        </td>
                                                        <td><a target="_blank" @click="_showingUserPic(item,true)"
                                                                itemprop="contentUrl" data-size="1600x950">
                                                                <img alt="" :src="getAdharImage(item.aadharcard)"
                                                                    v-if="item.gphoto || item.photo" class="avatar "
                                                                    itemprop="thumbnail" :alt="item.name">
                                                            </a>

                                                        </td>
                                                        <td>
                                                            <ul class="action" v-if="user.empdept != sd">
                                                                <li class="link" v-if="item.approval_status == 1"
                                                                    @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li>

                                                                <li class="edit" v-if="item.approval_status == 0"
                                                                    @click=""><i class="icon-pencil-alt"></i></li>
                                                                <li title="Room Reservation" v-if="!item.meeting_room"
                                                                    @click="meetingroomBook(item)">
                                                                    <i class="icon-home text-primary"></i>
                                                                </li>
                                                                <!--   <li class="link" @click="openlink(item)"><i
                                                                        class="icon-link"></i></li>-->
                                                                <li title="Delete Pass"  v-if="item.whom_userid != user.id && item.approval_status==0"
                                                                    @click="removeGatepass(item.gatepassid)"><i
                                                                        class="icon-trash text-danger"></i></li>
                                                                <li title="Print Pass"
                                                                    @click="print_pass(item.gatepassid)"><i
                                                                        class="icon-printer"></i></li>
                                                            </ul>
                                                            <ul class="action" v-else>
                                                                <li class="link" v-if="item.approval_status == 1"
                                                                    @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li>

                                                                <li title="Print Pass"
                                                                    @click="print_pass(item.gatepassid)"><i
                                                                        class="icon-printer"></i></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade  " id="report_table_tab" role="tabpanel"
                                aria-labelledby="report_table-tab">
                                <div class="card-body px-0 pb-0 pt-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Report </h6>
                                        <span class="badge bg-primary text-white" @click="filterReportlist"> <i
                                                class="icofont icofont-filter text-warning"></i> Filter</span>
                                        <span v-if="filter_summery_table_total_count>0"
                                            class="text-danger"><strong>&nbsp;&nbsp;Total
                                                {{filter_summery_table_total_count}} Visitors.</strong></span>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="report_table">
                                                <thead>
                                                    <tr>
                                                        <th v-for="h in filter_summery_table_headers" :key="h">{{ h }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="row in filter_summery_table_data" :key="row.Sr">
                                                        <td v-for="(h,index) in filter_summery_table_headers" :key="h"
                                                            :class="row[h]!='0' && index>2 ?'yes':'no'">{{ row[h] }}
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->
    <div class="modal fade" id="rescheduleHere" tabindex="-1" role="dialog" aria-labelledby="rescheduleHere"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Create Gate Pass </h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12 position-relative">
                            <label class="form-label">Purpose</label>

                            <select v-model="reschedule_data.purpose" class="form-select">
                                <option disabled selected>Select Purpose</option>
                                <option v-for="purpose in purpose_list" :key="purpose" :value="purpose">
                                    {{ purpose }}
                                </option>
                            </select>

                            <!--<input class="form-control" type="text" v-model="reschedule_data.purpose"-->
                            <!--    placeholder="Type Here..." required="">-->
                        </div>
                        <div class="col-md-12 position-relative">
                            <label class="form-label">Reschedule Date</label>
                            <input class="form-control" type="date" v-model="reschedule_data.date" :min="max_today_date"
                                placeholder="Type Here..." required="">
                        </div>

                    </div>
                    <div class="table-responsive custom-scrollbar">
                        <table class="table">
                            <tr v-for="(already_exist_row_here, index) in already_exist" :key="index">
                                <td class="text-danger">
                                    {{already_exist_row_here}}
                                </td>

                            </tr>

                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button class="btn btn-sm btn-primary" @click="reschedule_pass">Generate Pass</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="meetingroomBookHere" tabindex="-1" role="dialog" aria-labelledby="meetingroomBookHere"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Reserve Meeting Room</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div>Visitor Name : {{ room_booking_visitor.name }}</div>
                        <div>Visitor Purpose : {{ room_booking_visitor.purpose }}</div>
                        <div class="col-md-12 position-relative">
                            <label class="form-label">Meeting Purpose</label>
                            <input class="form-control" type="text" v-model="selected_room.purpose"
                                placeholder="Type Here..." required="">
                        </div>
                        <div class="row">

                            <div class="col-md-4 col-12">
                                <label class="form-label">From Time</label>
                                <input class="form-control" type="time" v-model="selected_room.schedule_time">
                            </div>
                            <div class="col-md-4 col-12">
                                <label class="form-label">To Time</label>
                                <input class="form-control" type="time" v-model="selected_room.upto_time">
                            </div>
                        </div>
                        <br>
                        <div class="col-sm-12">
                            <div class="row g-3">

                                <div class="col-md-2 col-4 position-relative " v-for="(item, index)  in rooms"
                                    :key="item.id" @click="show_booking(item.id)">
                                    <div :class="`${selected_room.roomid==item.id ? 'card bg-danger' : 'card bg-success'}`"
                                        @click="select_room(item.id)">
                                        <div
                                            :class="`${selected_room.roomid==item.id ? 'card-body bg-danger' : 'card-body bg-success'}`">
                                            <label class="form-label text-white">{{item.roomname}}</label>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>

                        <div>

                            <div v-if="rooms.length > 0">

                                <div v-if="bookinginfo.length > 0">

                                    <table class="table">
                                        <tr class="bg-info text-center">
                                            <td class=" text-white ">From</td>
                                            <td class=" text-white ">To</td>
                                            <td class=" text-white ">Staff Name</td>
                                            <td class=" text-white ">Status</td>
                                        </tr>
                                        <tr v-for="(item, index) in bookinginfo" :key="index"
                                            class=" text-center  text-danger">
                                            <td>{{ item.shedule_time }}</td>
                                            <td>{{ item.upto_time }}</td>
                                            <td>{{ item.emp_name }}</td>
                                            <td>{{ item.status==1 ? 'Booked':'Available' }}</td>
                                        </tr>
                                    </table>

                                </div>
                                <div v-else>
                                    <span><strong>Available Booking</strong></span>
                                </div>


                            </div>
                            <div v-else>
                                <span class="text-danger"><strong>Please Create Room</strong></span>
                            </div>

                        </div>






                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <div class="row">


                            <div class="col-md-5 col-12">
                                <button class="btn btn-sm btn-primary" @click="reserve_room"
                                    v-if="rooms.length>0">Reserve Meeting Room</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--<div class="modal fade" id="meetingroomBookHere" tabindex="-1" role="dialog" aria-labelledby="meetingroomBookHere"-->
    <!--    aria-hidden="true">-->
    <!--    <div class="modal-dialog modal-lg" role="document">-->
    <!--        <div class="modal-content">-->
    <!--            <div class="modal-header">-->
    <!--                <h4 class="modal-title">Reserve Meeting Room</h4>-->
    <!--                <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>-->
    <!--            </div>-->
    <!--            <div class="modal-body">-->
    <!--                <div class="modal-toggle-wrapper ">-->
    <!--                    <div>Visitor Name : {{ room_booking_visitor.name }}</div>-->
    <!--                    <div>Visitor Purpose : {{ room_booking_visitor.purpose }}</div>-->
    <!--                    <div class="col-sm-12">-->
    <!--                        <div class="row g-3">-->
    <!--                            <div class="col-md-2 col-4 position-relative " v-for="(item, index)  in rooms"-->
    <!--                                :key="item.id">-->
    <!--                                <div :class="`${selected_room.roomid == item.id ? 'card bg-danger' : 'card bg-success'}`"-->
    <!--                                    @click="select_room(room_booking_visitor.gatepassid, item.id)">-->
    <!--                                    <div-->
    <!--                                        :class="`${selected_room.roomid == item.id ? 'card-body bg-danger' : 'card-body bg-success'}`">-->
    <!--                                        <label class="form-label">{{ item.roomname }}</label>-->
    <!--                                    </div>-->
    <!--                                </div>-->
    <!--                            </div>-->

    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--            <div class="modal-footer">-->
    <!--                <div class="col-12">-->
    <!--                    <div class="row">-->
    <!--                        <div class="col-4">-->
    <!--                            <input class="form-control" type="date" v-model="selected_room.schedule_date">-->
    <!--                        </div>-->
    <!--                        <div class="col-3">-->
    <!--                            <input class="form-control" type="time" v-model="selected_room.schedule_time">-->
    <!--                        </div>-->
    <!--                        <div class="col-5">-->
    <!--                            <button class="btn btn-sm btn-primary" @click="reserve_room">Reserve Meeting-->
    <!--                                Room</button>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->
    <!--</div>-->
    <div class="modal fade" id="qrcodeView" tabindex="-1" role="dialog" aria-labelledby="qrcodeView" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">QR Code</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <canvas ref="qrcodeCanvas"></canvas>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">

                    </div>
                </div>
            </div>
        </div>
    </div>


    <div v-if="showModal" class="modal d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Accessories</h5>
                    <button type="button" class="close" @click="showModal = false" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="form-group d-flex align-items-center" v-for="(item, index) in accessories" :key="index">
                        <input type="hidden" v-model="accessories[index].gatepassid" />

                        <label class="me-2 mb-0">Name</label>
                        <input type="text" v-model="accessories[index].name" class="form-control me-2" />

                        <span @click="addAccessoryItem(accessories[index].gatepassid)" class="btn btn-primary">
                            <i class="fa fa-plus"></i>
                        </span> &nbsp;
                        <span @click="removeName(index)" class="btn btn-danger">
                            <i class="fa fa-trash"></i>
                        </span>
                    </div>
                </div>


                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="saveaccessories()">Save changes</button>
                </div>
            </div>
        </div>
    </div>


    <!-- filterModel -->




    <div class="modal" v-if="showfilterModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1"
        role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Filter</h5>
                    <button type="button" class="close" @click="showfilterModel = false" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="col-12 d-flex" style="gap: 10px;">
                      <label>
                        <input type="checkbox" name="vp_only" v-model="filter.isVisitorOnly" />
                        Visitor 
                      </label>
                      <label>
                        <input type="checkbox" name="wp_only" v-model="filter.isWpOnly" />
                        WP 
                      </label>
                    </div>
                    <div class="col-12 row">


                        <div class="col-6">
                            <label class="form-label">From Date</label>
                            <input class="form-control" type="date" v-model="filter.fromdate" placeholder="Type Here..."
                                required>
                        </div>

                        <div class="col-6">
                            <label class="form-label">To Date</label>
                            <input class="form-control" type="date" v-model="filter.todate" placeholder="Type Here..."
                                required>
                        </div>
                    </div>

                    <div class="col-12 row">

                        <div class="col-6 mt-2">
                            <label class="form-label">Firm Name</label>
                            <Autocomplete :items="firms" labelField="firmname" valueField="id" placeholder="Search Firm"
                                @select="handleSelectFirm" />





                            <!--<select class="form-control" v-model="filter.firmname" required>-->
                            <!--    <option value="0">All</option>-->
                            <!--    <option v-for="item in firms" :key="item.id" :value="item.firmname">-->
                            <!--        {{ item.firmname }}-->
                            <!--    </option>-->
                            <!--</select>-->
                        </div>



                        <div class="col-6 mt-2">
                            <label class="form-label">Visitor Name</label>

                            <Autocomplete :items="visitorname" labelField="name" valueField="id"
                                placeholder="Search Visitor" @select="handleSelectVisitor" />


                            <!--<select class="form-control" v-model="filter.visitorid" required>-->
                            <!--    <option value="0">All</option>-->
                            <!--    <option v-for="item in visitorname" :key="item.id" :value="item.id">-->
                            <!--        {{ item.name }} / {{ item.contact }} -->
                            <!--    </option>-->
                            <!--</select>-->
                        </div>
                        <div class="col-6 mt-2">
                            <label class="form-label">Employee Name</label>

                            <Autocomplete :items="employees_autocomplete" labelField="empname" valueField="id"
                                placeholder="Search Employee" @select="handleSelectEmployee" />
                        </div>

                        <div class="col-6 mt-2">
                            <label class="form-label">Department</label>

                            <Autocomplete :items="departments_autocomplete" labelField="deptname" valueField="id"
                                placeholder="Search Department" @select="handleSelectDepartment" />
                        </div>

                    </div>






                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-primary" @click="getfilterlist">Search</button>
                </div>
            </div>
        </div>
    </div>



    <div class="modal" v-if="showReportModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1"
        role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Report Filter</h5>
                    <button type="button" class="close" @click="showReportModel = false" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="col-12 row">
                     <div class="col-12">
                      <label>
                        <input type="checkbox" name="vp_only" v-model="filter.isVisitorOnly" />
                        Visitor Only
                      </label>
                      <label>
                        <input type="checkbox" name="wp_only" v-model="filter.isWpOnly" />
                        WP Only
                      </label>
                    </div>

                        <div class="col-6">
                            <label class="form-label">From Date</label>
                            <input class="form-control" type="date" v-model="filter.fromdate" placeholder="Type Here..."
                                required>
                        </div>

                        <div class="col-6">
                            <label class="form-label">To Date</label>
                            <input class="form-control" type="date" v-model="filter.todate" placeholder="Type Here..."
                                required>
                        </div>
                    </div>

                    <div class="col-12 row">

                        <div class="col-6 mt-2">
                            <label class="form-label">Firm Name</label>
                            <Autocomplete :items="firms" labelField="firmname" valueField="id" placeholder="Search Firm"
                                @select="handleSelectFirm" />





                            <!--<select class="form-control" v-model="filter.firmname" required>-->
                            <!--    <option value="0">All</option>-->
                            <!--    <option v-for="item in firms" :key="item.id" :value="item.firmname">-->
                            <!--        {{ item.firmname }}-->
                            <!--    </option>-->
                            <!--</select>-->
                        </div>



                        <div class="col-6 mt-2">
                            <label class="form-label">Visitor Name</label>

                            <Autocomplete :items="visitorname" labelField="name" valueField="id"
                                placeholder="Search Visitor" @select="handleSelectVisitor" />


                            <!--<select class="form-control" v-model="filter.visitorid" required>-->
                            <!--    <option value="0">All</option>-->
                            <!--    <option v-for="item in visitorname" :key="item.id" :value="item.id">-->
                            <!--        {{ item.name }} / {{ item.contact }} -->
                            <!--    </option>-->
                            <!--</select>-->
                        </div>
                        <div class="col-6 mt-2">
                            <label class="form-label">Employee Name</label>

                            <Autocomplete :items="employees_autocomplete" labelField="empname" valueField="id"
                                placeholder="Search Employee" @select="handleSelectEmployee" />
                        </div>

                        <div class="col-6 mt-2">
                            <label class="form-label">Department</label>

                            <Autocomplete :items="departments_autocomplete" labelField="deptname" valueField="id"
                                placeholder="Search Department" @select="handleSelectDepartment" />
                        </div>

                    </div>






                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-primary" @click="getfilterSummerylist">Search</button>
                </div>
            </div>
        </div>
    </div>















    <!-- filterModel -->





    <div class="modal fade" id="showingUserPic" tabindex="-1" role="dialog" aria-labelledby=" " aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{!showingUserPic.isadhar?'User Image':'Adhar Card'}}</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">

                            <img v-if="!showingUserPic.isadhar && showingUserPic.photo" alt=""
                                :src="getImageUrlV1(showingUserPic.photo)" class="img img-thumbnail"
                                :alt="showingUserPic.name" />

                            <img v-if="showingUserPic.isadhar && showingUserPic.photo" alt=""
                                :src="getAdharImage(showingUserPic.photo)" class="img img-thumbnail"
                                :alt="showingUserPic.name" />

                        </div>
                    </div>
                </div>
                <!--<div class="modal-footer">-->
                <!--    <div class="col-12">-->
                <!--        <button class="btn btn-primary" @click=""> </button>-->
                <!--    </div>-->
                <!--</div>-->
            </div>
        </div>
    </div>








    <!--<div class="modal" v-if="showimgModal" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1"-->
    <!--    role="dialog">-->
    <!--    <div class="modal-dialog" role="document">-->
    <!--        <div class="modal-content">-->
    <!--            <div class="modal-header">-->
    <!--                <h5 class="modal-title">Capture Image</h5>-->
    <!--                <button type="button" class="close" @click="closeimgModel" aria-label="Close">-->
    <!--                    <span aria-hidden="true">&times;</span>-->
    <!--                </button>-->
    <!--            </div>-->
    <!--            <div class="modal-body">-->
    <!--                <div class="row">-->

    <!--                    <div class="col-6 card text-center mb-5">-->
    <!--                        <video ref="video" autoplay style="height: 100px;"></video>-->

    <!--                    </div>-->
    <!--                    <div class="col-6">-->
                            <!-- <div class="avatar">
    <!--                        <img :src="photo" alt="Captured photo" class="img-100" style="height: 100px;">-->
    <!--                    </div>  -->-->
    <!--                        <canvas ref="canvas" style="height: 100px;"></canvas>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="row">-->
    <!--                    <span v-for="(device, index)  in preferredDevice" class="fw-bold">device.label</span>-->
    <!--                </div>-->
    <!--                <div class="row text-center">-->
    <!--                    <button type="button" class="btn btn-primary" @click="capture_photo"><i-->
    <!--                            class="icofont icofont-camera"></i> &nbsp; Capture</button>-->
    <!--                </div>-->
    <!--            </div>-->

    <!--            <div class="modal-footer">-->

    <!--                <button type="button" class="btn btn-success" @click="mark_checkin(imgpassid, 1)"><i-->
    <!--                        class="icofont icofont-ui-check"></i> &nbsp; Check In</button>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->
    <!--</div>-->
<div class="modal" v-if="showimgModal" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1"
    role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Capture Image</h5>
                <button type="button" class="close" @click="closeimgModel" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-6 card text-center mb-5">
                        <video ref="video" autoplay style="height: 100px;"></video>
                    </div>
                    <div class="col-6">
                        <canvas ref="canvas" style="height: 100px;"></canvas>
                    </div>
                </div>
                <div class="row mb-3 text-center">
                    <button v-if="videoDevices.length > 1" 
                            type="button" 
                            class="btn btn-secondary btn-sm" 
                            @click="switchCamera">
                        <i class="icofont icofont-exchange"></i> Switch Camera
                    </button>
                </div>
                <div class="row text-center">
                    <button type="button" class="btn btn-primary" @click="capture_photo">
                        <i class="icofont icofont-camera"></i> &nbsp; Capture
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="mark_checkin(imgpassid, 1)">
                    <i class="icofont icofont-ui-check"></i> &nbsp; Check In
                </button>
            </div>
        </div>
    </div>
</div>












    <ModalsPart v-if="!['login'].includes($route.name)" @getGatePassData="updateData" />
</template>
<style scoped>
.text_sm{
    font-size: 10px;
}
    .yes {
        background: #b3ffd1;
    }

    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 30px;
    }

    .badge_sm {
        padding: 2px 5px;
        border-radius: 10px;
        font-size: smaller;
        color: white;
    }

    .card-body p,
    .card-body h5 {
        margin-bottom: 0.25rem;
        /* Reduced spacing */
    }

    ul {
        gap: 10px;
    }
</style>

<style>
    .modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .modal-wrapper {
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        width: 400px;
    }

    @media only screen and (max-width: 991.98px) {
        .word_permit {
            top: 0px !important;

        }
    }

    .word_permit {
        position: relative;
        top: -20px;
        background: red;
        padding: 1px 1px;
        border-radius: 5px;
        color: white;
    }

    .card-img-top {
        height: 80px;
        width: 80px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    .badge-sm {
        font-size: 0.75rem;
        padding: 0.25em 0.4em;
    }

    .autocomplete-dropdown {
        max-height: 200px;
        overflow-y: auto;
    }

    .action {
        gap: 1px;
    }

    .gatepass-card {
        background: #fff;
        border-radius: 1rem;
        margin-bottom: 1.5rem;
        border: 1px solid gray;
        transition: all 0.3s ease-in-out;
    }
</style>


<script>
    // @ is an alias to /src 
    import PageTitle from '@/components/PageTitle.vue';
    import ModalsPart from '@/components/Modals.vue';
    import GatePass from '@/components/GatepassPrint.vue';

    import ExcelJS from 'exceljs';
    import { saveAs } from 'file-saver';


    // import axios from 'axios';
    import axios from "@/plugins/axios";
    import QRCode from 'qrcode';

    export default {
        name: 'CreateGatepass',
        components: {
            PageTitle, ModalsPart, GatePass
        },


        watch: {
            showimgModal(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        this.startWebcam();
                    });
                }
            },
            gatepass(newVal) {
                if (newVal) {
                    if (newVal && newVal.length > 0)
                        this.lastupdate = newVal[newVal.length - 1].iddate;
                }
            },

            search_text_today(newVal) {
                this.onSearchTypeToday(newVal);
            }
            ,
            search_text_all(newVal) {
                this.onSearchTypeAll(newVal);

            },
            
      
            
            ongoing_pass(newVal) {
                if (newVal && newVal.length) {
                    this.filterd_ongoing_pass = [...newVal];
                    // console.log('filtered updated');
                    console.log("Filtered list updated:", this.filterd_ongoing_pass.length);
                }
            },

            gatepass(newVal) {
                if (newVal) {
                    this.filterd_gatepass = [];
                    this.filterd_gatepass = newVal;
                    // this.refreshTable();
                }
            },

        },






        mounted() {
            if (this.$route.query.q)
                this.getBasics({ filter: this.$route.query.q });
            else if (this.$route.query.visitorid)
                this.getBasics({ isVisitor: this.$route.query.visitorid });
            else
                this.getBasics();


        },
        beforeUnmount() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                self.interval_status = false;

                console.log('Interval cleared');
            }
        },
        data() {

            return {

                accessories: {
                    gatepassid: '',
                    names: [''] // Initial empty array with one input field
                },
                showingUserPic: {
                    photo: '',
                    name: '',
                    isadhar: false
                },

                photo: '',
                imgpassid: '',
                gatepassimgid: '',



                showModal: false,
                showfilterModel: false,
                showReportModel: false,
                showimgModal: false,

                reschedule: [],
                user: [],
                gatepass: [],
                requested_pass: [],
                completed_pass: [],
                
                completed_pass_count:0,
                requested_pass_count:0,
                all_pass_count:0,
                
                ongoing_pass: [],//ongoing_pass passes = today gatepass
                rooms: [],
                room_booking_visitor: [],
                selected_room: { 'roomid': 0, 'gatepassid': 0, 'schedule_date': '', 'schedule_time': '' },
                reschedule_data: { 'date': '', 'purpose': '', 'time': '' },
                sd: 0,
                max_today_date: this.todayDate(),
                filter: {

                    fromdate: this.todayDate(),
                    todate: this.todayDate(),
                    firmname: '',
                    visitorid: '',
                    deptid: '',
                    employeeid: '',
                    isVisitorOnly: false,
                    isWpOnly: false


                },

                firms: [],
                visitorname: [],
                selected_gatepass_captured_img: '',
                preferredDevice: [],
                already_exist: [],
                bookinginfo: [],
                isLiveStarted: false,
                lastupdate: null,
                intervalId: null,
                interval_status: false,
                filterd_ongoing_pass: [],
                filterd_gatepass: [],
                search_text_today: '',
                search_text_all: '',

                //24.05.2025 
                departments_autocomplete: [],
                employees_autocomplete: [],
                filter_summery_table_headers: [],
                filter_summery_table_data: [],
                filter_summery_table_total_count: 0,
                purpose_list: [],//30.05.2025
                current_gatepass_id:0,
                
                //04.07.2025
                videoDevices: [],
        currentDeviceIndex: 0,
        currentStream: null,

            }
        },
        methods: {
            _showingUserPic(gatepass_row, isAdhar = false) {
                this.showingUserPic.name = gatepass_row.name;
                this.showingUserPic.photo = gatepass_row.gphoto || gatepass_row.photo;
                if (gatepass_row.workpermit_id > 0)
                    this.showingUserPic.photo = "wp/" + gatepass_row.gphoto || gatepass_row.photo;

                if (isAdhar)
                    this.showingUserPic.photo = gatepass_row.aadharcard;

                this.showingUserPic.isadhar = isAdhar;

                $("#showingUserPic").modal("toggle");
            },
            select_room(roomid) {
                this.selected_room.roomid = roomid;
                this.selected_room.gatepassid = this.room_booking_visitor.gatepassid;
            },
            meetingroomBook(item) {
                if(item.check_out!=null){
                    this.$swal('Already Checkout');
                    return;
                }
                this.room_booking_visitor = item;
                var today = new Date();
                var month = today.getMonth() + 1;
                this.selected_room.schedule_date = today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;
                this.selected_room.schedule_time = ((today.getHours() < 10) ? '0' + today.getHours() : today.getHours()) + ":" + ((today.getMinutes() < 10) ? '0' + today.getMinutes() : today.getMinutes());// today.getMinutes() ;


                $("#meetingroomBookHere").modal("show");

            },
            openlink(item) {
                window.open(window.location.origin + "/visitorpage?q=" + item.token, '_blank');
            },
            print_pass(gatepassid) {
                window.open(window.location.origin + "/printpass?q=" + gatepassid, '_blank');
            },
            updateData(value) { 
                
                
                if ($.fn.dataTable.isDataTable('#ongoing_table')) {
                                $('#ongoing_table').DataTable().destroy();
                }

                this.gatepass = value.gatepass;
                this.ongoing_pass = value.ongoing_pass;
                 this.$nextTick(() => {
                    var self = this;
                    $("#ongoing_table").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf', 'print'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                        "aaSorting": [],
                        
                        "pageLength": 20 ,
                        lengthChange: true
                    });
                });
            },
            getBasics(filter) {
                var self = this;
                axios.post('getGatepass', filter).then(function (response) {
                    
                    
                    self.all_pass_count=response.data.all_pass_count;
                    self.requested_pass_count=response.data.requested_pass_count;
                    self.completed_pass_count=response.data.completed_pass_count;
                    
                    
                    
                    self.gatepass = response.data.gatepass;
                    self.ongoing_pass = response.data.ongoing_pass;
                    
                    self.rooms = response.data.rooms;
                    self.user = response.data.user;
                    self.sd = response.data.sd;
                    self.firms = response.data.firms;

                    self.visitorname = response.data.visitorname;
                    //24.05.2025
                    self.employees_autocomplete = response.data.employees;
                    self.departments_autocomplete = response.data.departments;
                    self.departments_autocomplete.push({ "deptname": "ALL", "id": 99999999 })

                    //30.05.2025
                    self.purpose_list = response.data.purpose_list;

                    


                    if (!self.isLiveStarted) {
                        self.isLiveStarted = true;
                        self.interval_status = true;
                        self.intervalId = setInterval(self.refreshGatepass, 10000);
                    }
                    //  window.scrollTo(0, 0);
                }).then(() => {
                    self.refreshTable();
                });


                var today = new Date();
                var month = today.getMonth() + 1;
                this.reschedule_data.date = today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;
                this.reschedule_data.time = ((today.getHours() < 10) ? '0' + today.getHours() : today.getHours()) + ":" + ((today.getMinutes() < 10) ? '0' + today.getMinutes() : today.getMinutes());// today.getMinutes() ;

            },
            removeGatepass(id) {
                var self = this;
                self.$swal({
                    title: "Do You Want To Delete?",
                    text: "Are you sure? You won't be able to revert this!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes, Delete it!"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('removeGatepass', { gatepass_id: id }).then(function (response) {
                            self.destroyTable();
                            self.gatepass = response.data.gatepass;
                            self.ongoing_pass = response.data.ongoing_pass;
                            //  window.scrollTo(0, 0);
                        }).then(() => {
                            self.refreshTable();


                        });
                    }
                });

            },
            accept(visit) {
                var self = this;
                self.$swal({
                    title: "Do You Want To Accept?",
                    text: "Just For Confirmation !",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('acceptGatepass', { gatepass_id: visit.gatepassid }).then(function (response) {
                            self.destroyTable();
                            self.gatepass = response.data.gatepass;
                            // self.completed_pass = response.data.completed_pass;
                            // self.requested_pass = response.data.requested_pass;
                            self.ongoing_pass = response.data.ongoing_pass;
                            self.rooms = response.data.rooms;
                            self.user = response.data.user;
                            //  window.scrollTo(0, 0);
                        }).then(() => {
                            self.refreshTable();


                        });
                    }
                });

            },
            reject(visit) {
                var self = this;
                self.$swal({
                    title: "Do You Want To Decline?",
                    text: "Just For Confirmation !",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('declineGatepass', { gatepass_id: visit.gatepassid }).then(function (response) {
                            self.destroyTable();
                            self.gatepass = response.data.gatepass;
                            // self.completed_pass = response.data.completed_pass;
                            // self.requested_pass = response.data.requested_pass;
                            self.ongoing_pass = response.data.ongoing_pass;
                            self.rooms = response.data.rooms;
                            self.user = response.data.user;
                            //  window.scrollTo(0, 0);
                        }).then(() => {
                            self.refreshTable();


                        });
                    }
                });

            },
            containsKey(obj, key) {
                return Object.keys(obj).includes(key);
            },
            mark_checkin(passid, what) {

                var self = this;
                self.$swal({
                    title: "Do You Want To Check " + (what == 1 ? 'In' : 'Out') + "?",
                    text: "Just For Confirmation !",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed



                        const formData = new FormData();
                        if (what == 1) {
                            if(self.selected_gatepass_captured_img){
                                const blob = self.dataURLtoBlob(self.selected_gatepass_captured_img);
                                formData.append('image', blob, 'captured_photo.png');
                            } 
                        }
                        // formData.append('passid', passid);
                        formData.append('passid', passid);
                        formData.append('what', what);


                        axios.post('checkInUser', formData).then(function (response) {
                            self.destroyTable();

                            // if(self.containsKey(response.data, 'msg')){
                            self.$swal(response.data.msg);
                            // }else{
                            if (response.data.is == 1) {
                                self.showimgModal = false;
                                self.gatepass = response.data.gatepass;
                                // self.completed_pass = response.data.completed_pass;
                                // self.requested_pass = response.data.requested_pass;
                                self.ongoing_pass = response.data.ongoing_pass;
                                self.rooms = response.data.rooms;
                                self.user = response.data.user;
                            }
                            // }

                        }).then(() => {

                            self.refreshTable();


                        });
                    }
                });

            },
            mettingCompletedFromPass(id) {
                var self = this;
                self.$swal({
                    title: "Do You Want To Complete?",
                    text: "Just For Confirmation !",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('mettingCompletedFromPass', { id: id }).then(function (response) {
                            self.destroyTable();
                            if (response.data.is == 1) {
                                self.gatepass = response.data.gatepass;
                                self.ongoing_pass = response.data.ongoing_pass;

                            }
                            self.$swal(response.data.msg);


                        }).then(() => {
                            self.refreshTable();


                        });
                    }
                });
            },
            reserve_room(visit) {
                var self = this;
                self.$swal({
                    title: "Do You Want To Book?",
                    text: "Just For Confirmation !",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('bookMeetingRoom', { selected_room: self.selected_room }).then(function (response) {
                            self.destroyTable();
                            if (response.data.is == 1) {

                                self.gatepass = response.data.gatepass;
                                self.ongoing_pass = response.data.ongoing_pass;

                                $("#meetingroomBookHere").modal("toggle");

                                var today = new Date();
                                var month = today.getMonth() + 1;
                                var date_here_tmp = today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());
                                var time_here_tmp = ((today.getHours() < 10) ? '0' + today.getHours() : today.getHours()) + ":" + ((today.getMinutes() < 10) ? '0' + today.getMinutes() : today.getMinutes());

                                self.selected_room = { 'roomid': 0, 'gatepassid': 0, 'schedule_date': date_here_tmp, 'schedule_time': time_here_tmp };
                            }
                            self.$swal(response.data.msg);


                        }).then(() => {
                            self.refreshTable();


                        });
                    }
                });

            },
            async getQrCode(token) {
                try {
                    if (token.length > 0) {
                        const canvas = this.$refs.qrcodeCanvas;
                        var url = this.$api_host + 'vp?q=' + token;
                        // alert(url);
                        //var url= 'http://192.168.1.8:8081/visitorgatepassview?q='+token;
                        await QRCode.toCanvas(canvas, url, { width: 200 });
                        $("#qrcodeView").modal("toggle");
                    }

                } catch (error) {
                    console.error(error);
                }
            },
            getImageUrl(row) {
                //return `${this.$hostname}/writable/uploads/visitors/${image}`;
                let wp = '';
                if (row.workpermit_id > 0)
                    wp = 'wp/';

                if (row.gphoto && !row.gphoto.includes('.bin'))
                    return `${this.$hostname}writable/uploads/visitors/${wp + row.gphoto}`;
                else if (row.photo && !row.photo.includes('.bin'))
                    return `${this.$hostname}writable/uploads/visitors/${wp + row.photo}`;
                else
                    return `${this.$hostname}writable/visitors/user.png`;
            },




            selectUsers(id) {
                //   console.log(id);
                if (this.reschedule.includes(id)) {
                    this.reschedule.pop(id)
                } else {
                    this.reschedule.push(id)
                }
                console.log(this.reschedule);
            },
            reschedule_pass(item) {
                var self = this;
                if (this.reschedule.length > 0) {
                    axios.post('re_createGatePass', { reschedule: this.reschedule, reschedule_data: this.reschedule_data }).then(function (response) {
                        self.destroyTable();
                        if (response.data.already_exist && response.data.already_exist.length > 0)
                            self.already_exist = response.data.already_exist;
                        else if (response.data.gatepass_success == 1) {
                            $("#rescheduleHere").modal("toggle");
                            self.reschedule_data = { 'date': self.todayDate(), 'purpose': '', 'time': '' };
                        }

                        self.$swal(response.data.gatepass_statusmsg);
                        self.gatepass = response.data.gatepass;
                        // self.completed_pass = response.data.completed_pass;
                        // self.requested_pass = response.data.requested_pass;
                        self.ongoing_pass = response.data.ongoing_pass;

                    }).then(() => {
                        self.refreshTable();


                    });
                }
            },

            approve_checkout(visitid, what) {
                var self = this;
                self.$swal({
                    title: "Do You Want To Accept?",
                    text: "Just confirmation ?",
                    type: "warning",
                    showCancelButton: true,
                }).then((result) => { // <--
                    if (result.value) {
                        axios.post('approve_checkout', { gatepass_id: visitid, what: what }).then(function (response) {
                            self.destroyTable();
                            if (response.data.is == 1) {
                                self.gatepass = response.data.gatepass;
                                // self.completed_pass = response.data.completed_pass;
                                // self.requested_pass = response.data.requested_pass;
                                self.ongoing_pass = response.data.ongoing_pass;
                                self.rooms = response.data.rooms;
                                self.user = response.data.user;
                            }

                            self.$swal(response.data.gatepassReq);

                            //  window.scrollTo(0, 0);
                        }).then(() => {
                            self.refreshTable();
                        });
                    }
                });
            },

            destroyTable() {
                if ($.fn.dataTable.isDataTable('#ongoing_table')) {
                    $('#ongoing_table').DataTable().destroy();
                }

                if ($.fn.dataTable.isDataTable('#completed_table')) {
                    $('#completed_table').DataTable().destroy();
                }
                if ($.fn.dataTable.isDataTable('#all_table')) {
                    $('#all_table').DataTable().destroy();
                }
                if ($.fn.dataTable.isDataTable('#pending_table')) {
                    $('#pending_table').DataTable().destroy();
                }
            },
            getBase64Image(img) {
                const canvas = document.createElement("canvas");
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                return canvas.toDataURL("image/png");
            },
            refreshTable() {

                this.$nextTick(() => {
                    var self = this;

                    $("#ongoing_table").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf', 'print'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                        "aaSorting": [],
                        "pageLength": 20 ,
                        lengthChange: true
                    });

                    $("#completed_table").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf', 'print'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                        "aaSorting": [],
                        "pageLength": 20 ,
                        lengthChange: true
                    });

                    const exportButtons = [
                        {
                            extend: 'excelHtml5',
                            text: 'Excel',
                            exportOptions: {
                                columns: ':visible',
                                format: {
                                    body: function (data, row, column, node) {
                                        const parsed = $('<div>').html(data); // ✅ Safely parse
                                        const img = parsed.find('img');
                                        // if (img.length) return img.attr('src');
                                        if (img.length) {
                                            const href = img.attr('src');
                                            const text = "Image";
                                            return `<f>=HYPERLINK("${href}", "${text}")</f>`;
                                        }
                                        return parsed.text().trim();
                                    }
                                }
                            }
                        },
                        {
                            extend: 'pdfHtml5',
                            text: 'PDF',
                            orientation: 'landscape',
                            pageSize: 'A4',
                            customize: function (doc) {
                                const table = $('#all_table').DataTable();
                                const body = doc.content[1].table.body;

                                body.forEach((row, rowIndex) => {
                                    if (rowIndex === 0) return; // skip header row
                                    row.forEach((cell, cellIndex) => {
                                        const cellNode = table.cell(rowIndex - 1, cellIndex).node();
                                        const img = $(cellNode).find('img');
                                        if (img.length > 0) {
                                            const imgData = self.getBase64Image(img[0]);
                                            row[cellIndex] = {
                                                image: imgData,
                                                width: 50
                                            };
                                        }
                                    });
                                });
                            }
                        },
                        {
                            extend: 'print',
                            text: 'Print',
                            customize: function (win) {
                                $(win.document.body).css('font-size', '10pt');
                                $(win.document.body).find('img').css({
                                    'width': '60px',
                                    'height': '60px',
                                    'object-fit': 'cover'
                                });
                            }
                        },
                        {
                            text: 'Excel With Image',
                            action: function () {
                                self.exportTableToExcel();
                            }
                        },
                        {
                            text: 'Filter',
                            action: function () {
                                self.filterlist();
                            }
                        }

                    ];

                    $('#all_table').DataTable({
                        dom: 'Bfrtip',
                        buttons: exportButtons,
                        paging: true,
                        ordering: true,
                        autoWidth: false,
                        aaSorting: [],
                        order: [],
                        "pageLength": 20 ,
                        lengthChange: true
                    });


                    // $("#all_table").DataTable({
                    //     dom: 'Bfrtip',
                    //     buttons: ['excel', 'pdf', 'print',(self.user.empdept==self.sd || self.user.emprole==1)?{
                    //                             text: 'Filter',
                    //                             action: function (e, dt, node, config) {
                    //                               self.filterlist();
                    //                             }
                    //                           }:'csv'],
                    //     "paging": true,
                    //     "ordering": true,
                    //     "autoWidth": false,
                    //   "aaSorting": [],
                    //      order: [],
                    // });
                    $("#pending_table").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf', 'print'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                        "aaSorting": []
                    });
                });
            },

            editaccessories(id) {

                var self = this;
                self.current_gatepass_id=id;
                axios.post('editacessories', { id: id }).then((response) => {

                    self.accessories = response.data.accessories;


                    if (self.accessories.length == 0)
                        self.addAccessoryItem(id);

                    self.showModal = true;

                    //  window.scrollTo(0, 0);

                }).catch((error) => {
                    console.error('Error editing item:', error);
                });




            },

            addAccessoryItem(gatepassid) {
                this.accessories.push(
                    {
                        "name": "",
                        "gatepassid": gatepassid,

                    }
                ); // Add a new input field
            },

            removeName(index) {
                this.accessories.splice(index, 1);
            },

            saveaccessories() {
                var self = this;
                axios.post('saveaccessories', { accessories: self.accessories,gatepassid:self.current_gatepass_id }).then(function (response) {
                    self.destroyTable();
                    self.gatepass = response.data.gatepass;
                    self.msg = response.data.msg;
                    self.showModal = false;
                    self.$swal(self.msg);

                    //  window.scrollTo(0, 0);
                }).then(() => {
                    self.refreshTable();

                });


            },


            filterlist() {

                this.filter.visitorid = '';
                this.filter.firmname = '';


                this.filter.deptid = '';
                this.filter.employeeid = '';

                this.showfilterModel = true;


            },



            todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },

            getfilterlist() {
                var self = this;
                axios.post('getGatepassfilter', self.filter).then(function (response) {
                    self.destroyTable();

                    self.sucess = response.data.sucess;
                    if (self.sucess == 1) {
                        self.gatepass = response.data.gatepass;
                        self.all_pass_count=self.gatepass.length+'(Filtered)';
                        // self.completed_pass = response.data.completed_pass;
                        // self.requested_pass = response.data.requested_pass;
                        // self.ongoing_pass = response.data.ongoing_pass;
                        // self.rooms = response.data.rooms;
                        // self.user = response.data.user;
                        // self.sd = response.data.sd;
                        // self.firms = response.data.firms;

                        // self.visitorname = response.data.visitorname;


                        self.showfilterModel = false;
                        
                        self.completed_pass_count = response.data.completed_pass_count||0;
                        self.requested_pass_count = response.data.requested_pass_count||0;
                        

                    }





                    //  window.scrollTo(0, 0);
                }).then(() => {
                    self.refreshTable();

                });;



            },


            getCheckInDiff(checkIn) {
                const checkInDate = new Date(checkIn);
                const now = new Date();
                const diffMs = now - checkInDate; // Difference in milliseconds

                // Convert to more readable format (e.g., hours and minutes)
                const diffMins = Math.floor(diffMs / 60000);
                const hours = Math.floor(diffMins / 60);
                const minutes = diffMins % 60;
                if (hours > 0 || minutes > 0)
                    return `${hours}h ${minutes}m ago`;
                else
                    return '';
            },






            timeDiff(start, end) {
                if (end <= start)
                    return "";
                // Calculate difference in milliseconds
                const diffMs = new Date(end) - new Date(start);

                // Convert to hours and minutes
                const hours = Math.floor(diffMs / (1000 * 60 * 60));
                const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                // Return as an object or formatted string

                return (hours ? hours + " Hr," : '') + (minutes ? minutes + " Min" : '');


                // Or return as a formatted string:
                // return `${hours}h ${minutes}m`;
            },










            first_capture_photo(passid, itemid) {
                var self = this;

                self.imgpassid = passid;
                self.showimgModal = true;


            },





            capture_photo() {



                const video = this.$refs.video;
                const canvas = this.$refs.canvas;
                const context = canvas.getContext('2d');

                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                context.drawImage(video, 0, 0, canvas.width, canvas.height);

                this.selected_gatepass_captured_img = canvas.toDataURL('image/png');


            },


          async startWebcam() {
        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            this.videoDevices = devices.filter(device => device.kind === 'videoinput');
            
            if (this.videoDevices.length === 0) {
                console.error("No video devices found");
                return;
            }

            await this.activateCamera(0);
            
        } catch (error) {
            console.error("Error accessing webcam:", error);
        }
    },
    
    async switchCamera() {
        this.currentDeviceIndex = (this.currentDeviceIndex + 1) % this.videoDevices.length;
        await this.activateCamera(this.currentDeviceIndex);
    },
    
    async activateCamera(index) {
        // Stop the current stream if it exists
        if (this.currentStream) {
            this.currentStream.getTracks().forEach(track => track.stop());
        }
        
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: this.videoDevices[index].deviceId ? 
                            { exact: this.videoDevices[index].deviceId } : undefined
                }
            });
            
            this.currentStream = stream;
            this.$refs.video.srcObject = stream;
            
        } catch (error) {
            console.error("Error activating camera:", error);
        }
    },
    
    closeimgModel() {
        // Stop the stream when closing the modal
        if (this.currentStream) {
            this.currentStream.getTracks().forEach(track => track.stop());
        }
        this.showimgModal = false;
    },
            //  async startWebcam() {
            //         try {
            //             const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            //             this.$refs.video.srcObject = stream;
            //         } catch (error) {
            //             console.error("Error accessing webcam:", error);
            //         }
            //     },


            // capturePhoto() {
            //     const video = this.$refs.video;
            //     const canvas = this.$refs.canvas;
            //     const context = canvas.getContext('2d');

            //     canvas.width = video.videoWidth;
            //     canvas.height = video.videoHeight;
            //     context.drawImage(video, 0, 0, canvas.width, canvas.height);

            //     this.photo = canvas.toDataURL('image/png');

            //     //  this.save_workpermit();


            // },

            dataURLtoBlob(dataURL) {
                const byteString = atob(dataURL.split(',')[1]);
                const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], { type: mimeString });
            },

            // closeimgModel() {

            //     this.showimgModal = false

            //     const video = this.$refs.video;
            //     if (video && video.srcObject) {
            //         const stream = video.srcObject;
            //         const tracks = stream.getTracks();
            //         tracks.forEach(track => track.stop()); // Stop all media tracks
            //         video.srcObject = null; // Clean up
            //     }

            // },








            //04.05.2025 
            handleSelectFirm(selectedFirm) {
                this.filter.firmname = selectedFirm.firmname;
            },
            handleSelectVisitor(selectedVisitor) {
                console.log(selectedVisitor);
                this.filter.visitorid = selectedVisitor.id;
            },
            //24.05.2025
            handleSelectEmployee(selectedEmployee) {
                this.filter.employeeid = selectedEmployee.id;
            },
            handleSelectDepartment(selectedDepartment) {
                this.filter.deptid = selectedDepartment.id;
            },



            isMobileView() {
                //  return true;
                if (window.innerWidth <= 768) {
                    //   alert("Yes");
                    return true;
                } else {
                    // alert("No");
                    return false;
                }
            },


            //11.05.2025
            show_booking(id) {
                var self = this;
                axios.post('getRoomReservationinfo', { id: id, schedule_date: self.selected_room.schedule_date }).then(function (response) {
                    self.destroyTable();
                    self.bookinginfo = response.data.bookinginfo;

                    window.scrollTo(0, 0);
                }).then(() => {
                    self.refreshTable();


                });


            },

            //13.05.2025
            refreshGatepass() {
                var self = this;
                var havedata = false;

                axios.post('getGatepassUpdated', { lastupdate: self.lastupdate })
                    .then(function (response) {
                        if (response.data.ongoing_pass && response.data.ongoing_pass.length > 0) {
                            havedata = true;

                            // Destroy existing DataTable
                            if ($.fn.dataTable.isDataTable('#ongoing_table')) {
                                $('#ongoing_table').DataTable().destroy();
                            }
                            
                            // Update the data
                            self.ongoing_pass = response.data.ongoing_pass; 
                        }
                    })
                    .then(() => {
                        
                        // Wait for Vue DOM rendering to complete
                        if (havedata) {
                            
                                 console.log(self.filterd_ongoing_pass);
                               
                                // Initialize DataTable
                                $("#ongoing_table").DataTable({
                                    dom: 'Bfrtip',
                                    buttons: ['excel', 'pdf'],
                                    paging: true,
                                    ordering: true,
                                    autoWidth: false,
                                    "pageLength": 20 ,
                                    lengthChange: true,
                                    aaSorting: []
                                });
                                console.log("Table Refreshed");
                                // console.log($('#ongoing_table tbody tr').length);
                            
                        }
                    });
            },


            //15.05.2025
            getAdharImage(image) {
                //return `${this.$hostname}/writable/uploads/visitors/${image}`;

                // console.log("isAdhar : "+image);
                let path = "";
                if (image && !image.includes('.bin'))
                    path = `${this.$hostname}writable/uploads/aadhar_card/${image}`;
                else
                    path = `${this.$hostname}writable/visitors/user.png`;

                return path;
            },
            getImageUrlV1(image) {
                //return `${this.$hostname}/writable/uploads/visitors/${image}`;




                if (image && !image.includes('.bin'))
                    return `${this.$hostname}writable/uploads/visitors/${image}`;
                else
                    return `${this.$hostname}writable/visitors/user.png`;
            },
            onSearchTypeToday(query) {
                if (query) {
                    this.filterd_ongoing_pass = this.ongoing_pass.filter(item =>
                        item.name.toLowerCase().includes(query.toLowerCase()) ||
                        item.firmname.toLowerCase().includes(query.toLowerCase()) ||
                        item.contact.toLowerCase().includes(query.toLowerCase())
                    );
                } else {
                    this.filterd_ongoing_pass = this.ongoing_pass;
                }
            }
            ,
            onSearchTypeAll(query) {
                if (query) {
                    this.filterd_gatepass = this.gatepass.filter(item =>
                        item.name.toLowerCase().includes(query.toLowerCase()) ||
                        item.firmname.toLowerCase().includes(query.toLowerCase()) ||
                        item.contact.toLowerCase().includes(query.toLowerCase())
                    );
                } else {
                    this.filterd_gatepass = this.gatepass;
                }
            },

            async exportTableToExcel() {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Gatepass');

                // Define headers manually matching your table
                const headers = [
                    'Sr',
                    'Date',
                    'Photo',
                    'Visitor',
                    'Firmname',
                    'Contact',
                    'Purpose',
                    ...(this.user.empdept == this.sd || this.user.emprole == 1 ? ['Staff'] : []),
                    'Accessories',
                    'Check In',
                    'Check Out',
                    'Active Time',
                    'Check In Status',
                    'Check Out Status',
                    'Adhar Card',
                    'Is Workpermit',
                ];
                worksheet.addRow(headers);

                for (let i = 0; i < this.gatepass.length; i++) {
                    const item = this.gatepass[i];

                    // Add a new row without image
                    const row = [
                        i + 1,
                        item.schedule_date || '',
                        '', // Image placeholder
                        item.name || '',
                        item.firmname || '',
                        item.contact || '',
                        item.purpose || '',
                        ...(this.user.empdept == this.sd || this.user.emprole == 1 ? [item.whom_name || ''] : []),
                        item.accessories || '',
                        item.check_in || '',
                        item.check_out || '',
                        (item.check_out ? this.timeDiff(item.check_in, item.check_out) : this.getCheckInDiff(item.check_in)) || '',
                        (item.approval_status == 1 ? 'Accepted' : 'Pending') || '',
                        (item.checkout_approval == 1 ? 'Accepted (' + item.checkout_approval_time + ')' : 'Pending') || '',
                        (item.aadharcard ? this.getAdharImage(item.aadharcard) : '') || '',
                         (item?.workpermit_id>0?'YES':'NO'),
                    ];
                    worksheet.addRow(row);
                    //checkout_approval item.checkout_approval_time 
                    // Convert image URL to base64 and insert
                    if (item.gphoto) {
                        try {
                            const base64 = await this.getBase64FromUrl(this.getImageUrl(item));
                            const imageId = workbook.addImage({
                                base64: base64,
                                extension: 'jpeg', // or png
                            });
                            worksheet.addImage(imageId, {
                                tl: { col: 2, row: i + 1 }, // 0-indexed
                                ext: { width: 50, height: 50 },
                            });
                        } catch (error) {
                            console.warn('Image load failed for:', item.photo);
                        }
                    }

                    if (item.aadharcard) {
                        try {
                            const base64 = await this.getBase64FromUrl(this.getAdharImage(item.aadharcard));
                            const imageId = workbook.addImage({
                                base64: base64,
                                extension: 'jpeg', // or png
                            });
                            worksheet.addImage(imageId, {
                                tl: { col: 14, row: i + 1 }, // 0-indexed
                                ext: { width: 50, height: 50 },
                            });
                        } catch (error) {
                            console.warn('Image load failed for:', item.photo);
                        }
                    }

                }

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                saveAs(blob, 'gatepass_export.xlsx');
            },

            async getBase64FromUrl(url) {
                const response = await fetch(url, { mode: 'cors' });
                const blob = await response.blob();
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result); // full base64 string with mime
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            },

            stop_interval() {
                var self = this;
                if (self.interval_status && self.intervalId) {
                    clearInterval(self.intervalId);
                    self.interval_status = false;
                } else {
                    self.interval_status = true;
                    self.intervalId = setInterval(self.refreshGatepass, 10000);
                }
            },
            filter_list(what) {
                if ($.fn.dataTable.isDataTable('#ongoing_table')) {
                    $('#ongoing_table').DataTable().destroy();
                }
                if (what == 0) {

                    this.filterd_ongoing_pass = this.ongoing_pass.filter(item =>
                        item.check_in != null && item.check_out == null
                    );
                } else if (what == 1) {
                    this.filterd_ongoing_pass = this.ongoing_pass.filter(item =>
                        item.check_out != null
                    );
                } else if (what == 2) {
                    this.filterd_ongoing_pass = this.ongoing_pass.filter(item =>
                        item.check_in == null && item.approval_status==1
                    );
                }
                else {
                    this.filterd_ongoing_pass = this.ongoing_pass;
                }

                this.$nextTick(() => {
                    var self = this;
                    $("#ongoing_table").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf', 'print'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                        "aaSorting": [],
                        
                        "pageLength": 20 ,
                        lengthChange: true
                    });
                });
            },

            //24.05.2025

            filterReportlist() {

                this.filter.visitorid = '';
                this.filter.firmname = '';


                this.filter.deptid = '';
                this.filter.employeeid = '';

                this.showReportModel = true;


            },
            getfilterSummerylist() {
                var self = this;
                axios.post('getGatepassSummeryfilter', self.filter).then(function (response) {
                    if ($.fn.dataTable.isDataTable('#report_table')) {
                        $('#report_table').DataTable().destroy();
                    }

                    self.filter_summery_table_headers = response.data.headers;
                    self.filter_summery_table_data = response.data.data;
                    self.filter_summery_table_total_count = response.data.total_count;

                    self.showReportModel = false;






                    //  window.scrollTo(0, 0);
                }).then(() => {
                    self.$nextTick(() => {
                        $("#report_table").DataTable({
                            dom: 'Bfrtip',
                            buttons: ['excel', 'pdf', 'print'],
                            "paging": true,
                            "ordering": true,
                            "autoWidth": false,
                            "aaSorting": []
                        });
                    });
                });



            },
        },
    }
</script>